module.exports = __webpack_public_path__ + "img/screen-coming-soon.2c60f6a7.svg";